// (function ($) {
//   $(document).ready(function () {
//     const $resultsWrapper = $('.custom-product-list--collection');
//     const $collectionWrapper = $('.collection__dynamic-part');
//     const $showingCount = $('.collection-custom-count');
//     const $api = $('.custom-api-data');
//     const $error = $('.empty-state');
//     const smartSearchTimeout = 6000;
//     const itemsPerPage = 50;
//     const params = new URLSearchParams(window.location.search);
//     let query = params.get('q');
//     const $loader = $(`
//       <div class="custom-loader" style="text-align:center; padding:50px;">
//         <span>
//           <svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
//             <radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
//               <stop offset="0" stop-color="#000"></stop>
//               <stop offset=".3" stop-color="#000" stop-opacity=".9"></stop>
//               <stop offset=".6" stop-color="#000" stop-opacity=".6"></stop>
//               <stop offset=".8" stop-color="#000" stop-opacity=".3"></stop>
//               <stop offset="1" stop-color="#000" stop-opacity="0"></stop>
//             </radialGradient>
//             <circle transform-origin="center" fill="none" stroke="url(#a11)" stroke-width="15" stroke-linecap="round"
//               stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
//               <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0"
//                 keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
//             </circle>
//             <circle transform-origin="center" fill="none" opacity=".2" stroke="#000" stroke-width="15"
//               stroke-linecap="round" cx="100" cy="100" r="70"></circle>
//           </svg>
//         </span>
//       </div>
//     `);
//     $error.hide();
//     $collectionWrapper.before($loader);
//     $collectionWrapper.hide();

//     function cleanQuery(q) {
//       if (!q) return '';
//       q = q.trim();
//       if (q.includes('AND')) {
//         q = q.split('AND').pop().trim();
//       }
//       return q.replace(/\*/g, '');
//     }

//     if (query) {
//       query = cleanQuery(query);
//       doCustomSearch(query);
//     }

//     function doCustomSearch(query) {
//       $collectionWrapper.addClass('is-loading');
//       $loader.show();

//       let fallbackCalled = false;

//       const timer = setTimeout(() => {
//         if (!fallbackCalled) {
//           fallbackCalled = true;
//           fallbackShopifySearch(query);
//         }
//       }, smartSearchTimeout);

//       $.ajax({
//         url: 'https://mantener-vector-database-actualizada.replit.app/search',
//         method: 'POST',
//         contentType: 'application/json',
//         data: JSON.stringify({ query }),
//         success: function (response) {
//           clearTimeout(timer);
//           if (!response || !response.results || response.results.length === 0) {
//             if (!fallbackCalled) {
//               fallbackCalled = true;
//               fallbackShopifySearch(query);
//             }
//             return;
//           }
//           window.apiResults = response.results;
//           renderCustomResults(response.results, 1);
//           $collectionWrapper.removeClass('is-loading').show();
//           $loader.hide();
//           $api.show();
//           $error.hide();
//         },
//         error: function () {
//           clearTimeout(timer);
//           if (!fallbackCalled) {
//             fallbackCalled = true;
//             fallbackShopifySearch(query);
//           }
//           $error.show();
//           $api.hide();
//         },
//       });
//     }
//     function renderCustomResults(results, page = 1) {
//       const start = (page - 1) * itemsPerPage + 1;
//       const end = Math.min(start + itemsPerPage - 1, results.length);
//       const pageResults = results.slice(start - 1, end);

//       $resultsWrapper.html('');
//       if ($showingCount.length) {
//         $showingCount.text(`Mostrando ${start} - ${end} de ${results.length} resultados`).show();
//       }

//       pageResults.forEach((item) => {
//         const tags = window.customerInfo?.tags || [];
//         const isWholesale = window.customerInfo?.isLoggedIn && (
//           tags.includes('Mayorista') || tags.includes('mayorista C')
//         );
//         const retailPrice = Number(item.price);
//         let wholesalePrice = retailPrice * 0.85;
//         wholesalePrice = Math.floor(wholesalePrice * 100) / 100;
//         const formattedRetail = retailPrice.toLocaleString('es-GT', {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         });
//         const formattedWholesale = wholesalePrice.toLocaleString('es-GT', {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         });
//         let priceHtml = '';
//         if (isWholesale) {
//           priceHtml = `
//             <span class="price price--highlight swap">Q${formattedWholesale}</span>
//             <span class="price price--compare">Q${formattedRetail}</span>
//           `;
//         } else {
//           priceHtml = `<span class="price">Q${formattedRetail}</span>`;
//         }
//         let labelHtml = '';
//         let tag = item.tags || [];
//         if (typeof tag === 'string') {
//           tag = tag.split(',').map(tag => tag.trim());
//         }
//         if (tag.includes('SlowBack')) {
//           labelHtml += `<span class="product-label product-label--custom3">${settings.SlowBack_text_tag}</span>`;
//         } else if (tag.includes('Backorder_GT')) {
//           labelHtml += `<span class="product-label product-label--custom3 backorder_gt">${settings.popup_text_GT}</span>`;
//         } else if (tag.includes('xela')) {
//           labelHtml += `<span class="product-label product-label--custom4" style="--background:${settings.xela_bg}">${settings.xela_tag_text}</span>`;
//         } else if (tag.includes('Xela')) {
//           labelHtml += `<span class="product-label product-label--custom4" style="--background:${settings.xela_bg}">${settings.xela_tag_text}</span>`;
//         } else if (tag.includes('Backorder') || tag.includes('BajoPPLCD')) {
//           labelHtml += `<span class="product-label product-label--custom3">${settings.popup_text}</span>`;
//         } else {
//           labelHtml += `<span class="product-label product-label--custom10">${settings.quantity_stock}</span>`;
//         }
//         if (isWholesale) {
//           labelHtml += `<span class="product-label product-label--on-sale">Precio Mayorista</span>`;
//         }
//         let inventoryText = '';
//         let inventoryClass = 'inventory--high';
//         if (item.available_quantity <= 0) {
//           inventoryText = 'Sin stock';
//           inventoryClass = 'product-item__inventory inventory inventory--low';
//         } else if (item.available_quantity === 1) {
//           inventoryText = `Solo quedan ${item.available_quantity} unidades`;
//           inventoryClass = 'product-item__inventory inventory inventory--low';
//         } else if (item.available_quantity < 5) {
//           inventoryText = `+${item.available_quantity} Unidades Disponibles`;
//         } else {
//           inventoryText = `+${item.available_quantity} unidades disponibles`;
//         }
//         let specialBadge = '';
//         if (item.price >= 500) {
//           specialBadge = `
//             <span class="collection-view-label">
//               <img src="https://cdn.shopify.com/s/files/1/1415/3600/files/Untitled-1.png" alt="High Value">
//             </span>
//           `;
//         }
//         const html = `
//           <div class="product-item product-item--vertical 1/3--tablet 1/4--lap-and-up">
//             <div class="product-item__label-list">${labelHtml}</div>
//             <a class="collection-view-image" href="${item.url}">
//               ${specialBadge}
//               <div class="aspect-ratio aspect-ratio--square" style="padding-bottom: 133.3333%">
//                 <img class="product-item__primary-image" src="${item.image_url}" alt="${item.name}">
//               </div>
//             </a>
//             <div class="product-item__info">
//               <span class="product-item__inventory inventory ${inventoryClass}">${inventoryText}</span>
//               <div class="product-item__info-inner">
//                 <div class="product-item__price-list price-list">
//                   <span class="price">${priceHtml}</span>
//                 </div>
//                 <a href="${item.url}" class="product-item__title text--strong link">${item.name}</a>
//               </div>
//               <form method="post" action="/cart/add" class="add-to-cart-form" data-product-id="${item.id}">
//                 <input type="hidden" name="id" value="${item.variant_id}">
//                 <button type="submit" class="custom-product-items-class product-item__action-button button button--small button--primary">
//                   + Agregar al carrito
//                 </button>
//               </form>
//             </div>
//           </div>
//         `;
//         $resultsWrapper.append(html);


//       });

//       renderPagination(results.length, page);
//     }

//     function renderPagination(totalItems, currentPage) {
//       const totalPages = Math.ceil(totalItems / itemsPerPage);
//       const $paginationContainer = $('.pagination');
//       if (!$paginationContainer.length) {
//         $('.collection__dynamic-part').append(
//           '<div class="pagination"><div class="pagination__inner"><div class="pagination__nav"></div></div></div>'
//         );
//       }
//       const $nav = $('.pagination__nav');
//       $nav.html('');

//       if (currentPage > 1)
//         $nav.append(`<a href="#" class="pagination__prev link" data-page="${currentPage - 1}">Anterior</a>`);

//       for (let i = 1; i <= totalPages; i++) {
//         if (i === currentPage) {
//           $nav.append(`<span class="pagination__nav-item is-active">${i}</span>`);
//         } else if (i <= 2 || i > totalPages - 2 || (i >= currentPage - 1 && i <= currentPage + 1)) {
//           $nav.append(`<a href="#" class="pagination__nav-item link" data-page="${i}">${i}</a>`);
//         } else if (i === 3 && currentPage > 4) {
//           $nav.append(`<span class="pagination__nav-item">…</span>`);
//         } else if (i === totalPages - 2 && currentPage < totalPages - 3) {
//           $nav.append(`<span class="pagination__nav-item">…</span>`);
//         }
//       }

//       if (currentPage < totalPages)
//         $nav.append(`<a href="#" class="pagination__next link" data-page="${currentPage + 1}">Siguiente</a>`);

//       $('.pagination__page-count').remove();
//       $('.pagination__inner').append(`<span class="pagination__page-count">Página ${currentPage} / ${totalPages}</span>`);

//       $('.pagination__nav-item.link, .pagination__prev, .pagination__next')
//         .off('click')
//         .on('click', function (e) {
//           e.preventDefault();
      var sfCbs = document.querySelectorAll("#sf-checkboxes input[type=checkbox]");
      for (var sc = 0; sc < sfCbs.length; sc++) { sfCbs[sc].checked = false; }
      var sfClearBtn = document.getElementById("sf-clear");
      if (sfClearBtn) sfClearBtn.classList.remove("sf-visible");
//           const page = parseInt($(this).data('page'));
//           if (page) renderCustomResults(window.apiResults, page);
//         });
//     }
//     function fallbackShopifySearch(query) {
//       fetch(`/search?view=ajax&q=${encodeURIComponent(query)}&type=product`)
//         .then((res) => res.text())
//         .then((html) => {
//           $collectionWrapper.removeClass('is-loading').show();
//           $loader.hide();
//           $showingCount.show();
//         })
//         .catch((err) => {
//           console.error('Shopify fallback search failed', err);
//           $collectionWrapper.removeClass('is-loading').show();
//           $loader.hide();
//         });
//     }
//     $(document).on('submit', '.search-bar', function (e) {
//       const $input = $(this).find('input[name="q"]');
//       let query = cleanQuery($input.val());
//       $input.val(query);
//     });
//   });
// })(jQuery);
(function ($) {
  $(document).ready(function () {
    const $resultsWrapper = $('.custom-product-list--collection');
    const $collectionWrapper = $('.collection__dynamic-part');
    const $showingCount = $('.collection-custom-count');
    const $api = $('.custom-api-data');
    const $error = $('.empty-state');
    const smartSearchTimeout = 6000;
    const itemsPerPage = 50;
    const params = new URLSearchParams(window.location.search);
    let query = params.get('q');
    const isFallback = params.get('fallback') === '1';
    const $loader = $(`
      <div class="custom-loader" style="text-align:center; padding:50px;">
        <span>
          <svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
            <radialGradient id="a11" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
              <stop offset="0" stop-color="#000"></stop>
              <stop offset=".3" stop-color="#000" stop-opacity=".9"></stop>
              <stop offset=".6" stop-color="#000" stop-opacity=".6"></stop>
              <stop offset=".8" stop-color="#000" stop-opacity=".3"></stop>
              <stop offset="1" stop-color="#000" stop-opacity="0"></stop>
            </radialGradient>
            <circle transform-origin="center" fill="none" stroke="url(#a11)" stroke-width="15" stroke-linecap="round"
              stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
              <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0"
                keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
            </circle>
            <circle transform-origin="center" fill="none" opacity=".2" stroke="#000" stroke-width="15"
              stroke-linecap="round" cx="100" cy="100" r="70"></circle>
          </svg>
        </span>
      </div>
    `);
    $error.hide();
    $collectionWrapper.before($loader);
    $collectionWrapper.hide();

    function cleanQuery(q) {
      if (!q) return '';
      q = q.trim();
      if (q.includes('AND')) {
        q = q.split('AND').pop().trim();
      }
      return q.replace(/\*/g, '');
    }

    if (query) {
      query = cleanQuery(query);
      if (isFallback) {
        $loader.hide();
        $collectionWrapper.removeClass('is-loading').show();
      } else {
        doCustomSearch(query);
      }
    } else if ($('#search-hero-container').length) {
      $loader.hide();
      $collectionWrapper.hide();
      $api.hide();
      $('.cl-modern').hide();
      $('#search-hero-container').show();
    }

function doCustomSearch(query) {
  $collectionWrapper.addClass('is-loading');
  $loader.show();

  $.ajax({
    url: 'https://mantener-vector-database-actualizada.replit.app/search',
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({ query }),
    timeout: smartSearchTimeout,

    success: function (response) {
      if (!response || !response.results || response.results.length === 0) {
        fallbackShopifySearch(query);
        return;
      }

      window.apiResults = response.results;
      renderCustomResults(response.results, 1);

      $collectionWrapper.removeClass('is-loading').show();
      $loader.hide();
      $api.show();
      $error.hide();
    },

    error: function (xhr, status, errorThrown) {
      fallbackShopifySearch(query);
    },
  });
}


    function renderCustomResults(results, page = 1) {
      const start = (page - 1) * itemsPerPage + 1;
      const end = Math.min(start + itemsPerPage - 1, results.length);
      const pageResults = results.slice(start - 1, end);

      $resultsWrapper.html('');
      if ($showingCount.length) {
        $showingCount.text(`Mostrando ${start} - ${end} de ${results.length} resultados`).show();
      }

      pageResults.forEach((item) => {
        const tags = window.customerInfo?.tags || [];
        const isWholesale = window.customerInfo?.isLoggedIn && (
          tags.some(t => t.toLowerCase() === 'mayorista' || t.toLowerCase() === 'mayoristac' || t.toLowerCase() === 'mayorista c')
        );
        const forceDisableWholesale = typeof window.isDisableWholesaleFlag === 'function'
          ? window.isDisableWholesaleFlag(item.disable_wholesale)
          : (item.disable_wholesale === true
            || item.disable_wholesale === 'true'
            || item.disable_wholesale === 1
            || item.disable_wholesale === '1');
        const showDiscountedPrice = isWholesale || forceDisableWholesale;
        const retailPrice = Number(item.price);
        const discountPct = (window.wholesaleDiscountPercent != null ? window.wholesaleDiscountPercent : 15) / 100;
        let wholesalePrice = retailPrice * (1 - discountPct);
        wholesalePrice = Math.round(wholesalePrice);
        const formattedRetail = Math.round(retailPrice).toLocaleString('es-GT', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        const formattedWholesale = wholesalePrice.toLocaleString('es-GT', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        let priceHtml = '';
        if (showDiscountedPrice) {
          priceHtml = `
            <span class="price price--highlight swap">Q${formattedWholesale}</span>
            <span class="price price--compare"><s>Q${formattedRetail}</s></span>
          `;
        } else {
          priceHtml = `
            <span class="price">Q${formattedRetail}</span>
          `;
        }
        let labelHtml = '';
        let tag = item.tags || [];
        if (typeof tag === 'string') {
          tag = tag.split(',').map(tag => tag.trim());
        }

        const tagsToHideInventory = ['SlowBack', 'Backorder', 'BajoPPLCD'];
        const hideInventory = tag.some(t => tagsToHideInventory.includes(t));

        let deliveryType = 'inmediata';
        const tagsLower = tag.map(t => t.toLowerCase());
        if (tagsLower.includes('xela') || tagsLower.includes('marketplace')) {
          deliveryType = '24hrs';
        } else if (tagsLower.includes('slowback')) {
          deliveryType = '10dias';
        } else if (tagsLower.includes('backorder') || tagsLower.includes('bajopplcd')) {
          deliveryType = '7dias';
        }

        if (tag.includes('SlowBack')) {
          labelHtml += `<span class="product-label product-label--custom3">${settings.SlowBack_text_tag}</span>`;
        } else if (tag.includes('Backorder_GT')) {
          labelHtml += `<span class="product-label product-label--custom3 backorder_gt">${settings.popup_text_GT}</span>`;
        } else if (tag.includes('xela')) {
          labelHtml += `<span class="product-label product-label--custom4" data-xela-badge data-stock-gt="false" style="--background:${settings.xela_bg}"><span data-xela-badge-text>${settings.xela_tag_text}</span></span>`;
        } else if (tag.includes('Xela')) {
          labelHtml += `<span class="product-label product-label--custom4" data-xela-badge data-stock-gt="false" style="--background:${settings.xela_bg}"><span data-xela-badge-text>${settings.xela_tag_text}</span></span>`;
        } else if (tag.includes('Backorder') || tag.includes('BajoPPLCD')) {
          labelHtml += `<span class="product-label product-label--custom3">${settings.popup_text}</span>`;
        } else {
          labelHtml += `<span class="product-label product-label--custom10"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>${settings.quantity_stock}</span>`;
        }

        if (isWholesale) {
          labelHtml += `<span class="mayorista-price-pill mayorista-price-pill--label"><svg class="mayorista-price-pill__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg> Precio Mayorista</span>`;
        }

        if (item.recomendado === true) {
          labelHtml += `<span class="product-label-list__break" aria-hidden="true"></span>`;
          labelHtml += `<button type="button" class="product-label product-label--recomendado js-recomendado-info" aria-label="¿Qué significa Recomendado? Más información"><svg class="product-label__star" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg><span class="product-label__text">Recomendado</span><svg class="product-label__help" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></button>`;
        }

        let inventoryText = '';
        let inventoryClass = 'inventory--high';
        if (item.available_quantity <= 0) {
          inventoryText = 'Sin stock';
          inventoryClass = 'product-item__inventory inventory inventory--low';
        } else if (item.available_quantity === 1) {
          inventoryText = `Solo quedan ${item.available_quantity} unidades`;
          inventoryClass = 'product-item__inventory inventory inventory--low';
        } else if (item.available_quantity < 5) {
          inventoryText = `+${item.available_quantity} Unidades Disponibles`;
        } else {
          inventoryText = `+${item.available_quantity} unidades disponibles`;
        }

        let inventoryHtml = '';
        if (!hideInventory) { 
          inventoryHtml = `<span class="product-item__inventory inventory ${inventoryClass}">${inventoryText}</span>`;
        }

        let freeShippingBadge = '';
        if (item.price >= 250) {
          freeShippingBadge = `<span class="envio-gratis-pill--image"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> Envío gratis</span>`;
        }

        const handleMatch = (item.url || '').match(/\/products\/([^?#/]+)/);
        const productHandle = handleMatch ? handleMatch[1] : '';

        const html = `
          <div class="product-item product-item--vertical 1/3--tablet 1/4--lap-and-up" data-delivery="${deliveryType}" data-product-handle="${productHandle}">
            <div class="product-item__label-list">${labelHtml}</div>
            <a class="collection-view-image" href="${item.url}">
              <span class="cart-badge" data-cart-badge="${item.id}" style="display:none;">
                <svg class="cart-badge__icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
                <span class="cart-badge__qty">0</span>
              </span>
              ${freeShippingBadge}
              <div class="aspect-ratio aspect-ratio--square" style="padding-bottom: 133.3333%">
                <img class="product-item__primary-image" src="${item.image_url}" alt="${item.name}">
              </div>
            </a>
            <div class="product-item__info">
              ${inventoryHtml} <div class="product-item__info-inner">
                <div class="product-item__price-list price-list">
                  <span class="price">${priceHtml}</span>
                </div>
                <a href="${item.url}" class="product-item__title text--strong link">${item.name}</a>
              </div>
              <form method="post" action="/cart/add" class="add-to-cart-form" data-product-id="${item.id}">
                <input type="hidden" name="id" value="${item.variant_id}">
                ${tag.some(t => t.toLowerCase() === 'new-pricing') ?
                  '<input type="hidden" name="properties[bulk]" value="bulk"><input type="hidden" name="quantity" value="25">' :
                  '<input type="hidden" name="quantity" value="1">'}
                ${isWholesale && !tag.some(t => t.toLowerCase() === 'new-pricing') && item.available_quantity > 0 ? `
                <div class="pi-qty-selector" style="display:none;" data-pi-qty-pending data-pi-qty-max="${Math.min(item.available_quantity || 15, 15)}">
                  <button type="button" class="pi-qty-selector__btn pi-qty-selector__btn--minus" data-pi-qty="minus" disabled aria-label="Menos">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </button>
                  <span class="pi-qty-selector__value" data-pi-qty-display>1</span>
                  <button type="button" class="pi-qty-selector__btn pi-qty-selector__btn--plus" data-pi-qty="plus" aria-label="Más">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  </button>
                </div>` : ''}
                <button type="submit" class="custom-product-items-class product-item__action-button button button--small button--primary"${item.available_quantity <= 0 ? ' disabled' : ''}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Agregar
                </button>
              </form>
            </div>
          </div>
        `;
        $resultsWrapper.append(html);
      });

      renderPagination(results.length, page);
      enrichXelaMetafields();
      enrichVariantGating();
      if (window.CartBadge) window.CartBadge.refresh();
    }

    var xelaMetaCache = {};
    var xelaEnrichVersion = 0;

    function enrichXelaMetafields() {
      var currentVersion = ++xelaEnrichVersion;
      var cards = $resultsWrapper.find('.product-item[data-delivery="inmediata"][data-product-handle]');
      if (!cards.length) return;

      cards.each(function() {
        var card = $(this);
        var handle = card.attr('data-product-handle');
        if (!handle) return;

        if (xelaMetaCache[handle] !== undefined) {
          applyXelaMeta(card, xelaMetaCache[handle], currentVersion);
          return;
        }

        $.get('/products/' + handle + '?view=xela-meta')
          .done(function(response) {
            var meta;
            try { meta = typeof response === 'string' ? JSON.parse(response.trim()) : response; } catch(e) { meta = null; }
            xelaMetaCache[handle] = meta;
            applyXelaMeta(card, meta, currentVersion);
          })
          .fail(function() { xelaMetaCache[handle] = null; });
      });
    }

    function applyXelaMeta(card, meta, version) {
      if (version !== xelaEnrichVersion) return;
      if (!meta) return;
      if (!$.contains(document.documentElement, card[0])) return;

      var labelList = card.find('.product-item__label-list');
      var existingLabel = labelList.find('.product-label--custom10');

      if (meta.stock_xela) {
        if (meta.stock_guatemala) {
          var dualHtml = '<div class="xela-stock-dual" data-stock-gt="true">'
            + '<span class="product-label product-label--custom10 xela-stock-dual__stock"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>' + (window.settings ? window.settings.quantity_stock : 'En Stock') + '</span>'
            + '<span class="product-label product-label--custom4 xela-stock-dual__xela" data-xela-badge data-stock-gt="true" style="--background:' + (window.settings ? window.settings.xela_bg : '#ff6200') + '"><span data-xela-badge-text>' + (window.settings ? window.settings.xela_tag_text : 'Envío de Xela') + '</span></span>'
            + '</div>';
          if (existingLabel.length) {
            existingLabel.replaceWith(dualHtml);
          } else {
            labelList.prepend(dualHtml);
          }
        } else {
          var xelaBadgeHtml = '<span class="product-label product-label--custom4" data-xela-badge data-stock-gt="false" style="--background:' + (window.settings ? window.settings.xela_bg : '#ff6200') + '"><span data-xela-badge-text>' + (window.settings ? window.settings.xela_tag_text : 'Envío de Xela') + '</span></span>';
          if (existingLabel.length) {
            existingLabel.replaceWith(xelaBadgeHtml);
          } else {
            labelList.prepend(xelaBadgeHtml);
          }
          card.attr('data-delivery', '24hrs');
        }
      } else if (meta.stock_guatemala) {
        var stockText = window.settings ? window.settings.quantity_stock : 'En Stock';
        var gtOnlyHtml = '<span class="product-label product-label--custom10" data-gt-only="true"><svg class="stock-icon-svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg><span class="stock-badge-text">' + stockText + '</span></span>';
        if (existingLabel.length) {
          existingLabel.replaceWith(gtOnlyHtml);
        } else {
          labelList.prepend(gtOnlyHtml);
        }
      }
    }

    function renderPagination(totalItems, currentPage) {
      const totalPages = Math.ceil(totalItems / itemsPerPage);
      const $paginationContainer = $('.pagination');
      if (!$paginationContainer.length) {
        $('.collection__dynamic-part').append(
          '<div class="pagination"><div class="pagination__inner"><div class="pagination__nav"></div></div></div>'
        );
      }
      const $nav = $('.pagination__nav');
      $nav.html('');

      if (currentPage > 1)
        $nav.append(`<a href="#" class="pagination__prev link" data-page="${currentPage - 1}">Anterior</a>`);

      for (let i = 1; i <= totalPages; i++) {
        if (i === currentPage) {
          $nav.append(`<span class="pagination__nav-item is-active">${i}</span>`);
        } else if (i <= 2 || i > totalPages - 2 || (i >= currentPage - 1 && i <= currentPage + 1)) {
          $nav.append(`<a href="#" class="pagination__nav-item link" data-page="${i}">${i}</a>`);
        } else if (i === 3 && currentPage > 4) {
          $nav.append(`<span class="pagination__nav-item">…</span>`);
        } else if (i === totalPages - 2 && currentPage < totalPages - 3) {
          $nav.append(`<span class="pagination__nav-item">…</span>`);
        }
      }

      if (currentPage < totalPages)
        $nav.append(`<a href="#" class="pagination__next link" data-page="${currentPage + 1}">Siguiente</a>`);

      $('.pagination__page-count').remove();
      $('.pagination__inner').append(`<span class="pagination__page-count">Página ${currentPage} / ${totalPages}</span>`);

      $('.pagination__nav-item.link, .pagination__prev, .pagination__next')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
      var sfCbs = document.querySelectorAll("#sf-checkboxes input[type=checkbox]");
      for (var sc = 0; sc < sfCbs.length; sc++) { sfCbs[sc].checked = false; }
      var sfClearBtn = document.getElementById("sf-clear");
      if (sfClearBtn) sfClearBtn.classList.remove("sf-visible");
          const page = parseInt($(this).data('page'));
          if (page) renderCustomResults(window.apiResults, page);
        });
    }

    var variantCache = {};
    function enrichVariantGating() {
      var cards = $resultsWrapper.find('.product-item[data-product-handle]');
      if (!cards.length) return;
      cards.each(function() {
        var card = $(this);
        var handle = card.attr('data-product-handle');
        if (!handle) return;
        var sel = card.find('.pi-qty-selector[data-pi-qty-pending]');
        if (!sel.length) return;
        var cached = variantCache[handle];
        if (cached !== undefined) {
          if (cached.count === 1) {
            sel.attr('data-pi-qty-max', cached.max);
            sel.removeAttr('data-pi-qty-pending').css('display', '');
          } else {
            sel.remove();
          }
          return;
        }
        $.getJSON('/products/' + handle + '.js')
          .done(function(product) {
            var count = product && product.variants ? product.variants.length : 1;
            var max = 15;
            if (count === 1) {
              var invQty = product.variants[0].inventory_quantity;
              if (invQty > 0) max = Math.min(invQty, 15);
              sel.attr('data-pi-qty-max', max);
              sel.removeAttr('data-pi-qty-pending').css('display', '');
            } else {
              sel.remove();
            }
            variantCache[handle] = { count: count, max: max };
          })
          .fail(function() {
            variantCache[handle] = { count: 0, max: 0 };
            sel.remove();
          });
      });
    }

    function fallbackShopifySearch(query) {
      window.location.href = `/search?q=${encodeURIComponent(query)}&type=product&fallback=1`;
    }

    $(document).on('submit', '.search-bar', function (e) {
      const $input = $(this).find('input[name="q"]');
      let query = cleanQuery($input.val());
      $input.val(query);
    });



    $(document).on('click', '.sf-mobile-bar__type-pill', function (e) {
      e.preventDefault();
      var val = $(this).data('type-value');
      $(this).toggleClass('active');
      var cb = document.querySelector('#sf-checkboxes input[value="' + val + '"]');
      if (cb) {
        cb.checked = !cb.checked;
        var evt = new Event('change', { bubbles: true });
        cb.dispatchEvent(evt);
      }
    });
    $(document).on('click', '#sf-mobile-filter-btn', function (e) {
      e.preventDefault();
      var sidebar = document.getElementById('sf-sidebar');
      if (sidebar) {
        sidebar.classList.toggle('sf-open');
        var hasFilters = sidebar.classList.contains('sf-open');
        $(this).toggleClass('sf-has-filters', hasFilters);
      }
    });
  });
})(jQuery);

// custom js ---------------------------------------------===================================

(function ($) {
  $(document).ready(function () {
    const $filterBar = $('.main-filter-bar-for-search');
    $filterBar.hide();
    $('.redirect-tag-id[data-id="Todo"]').addClass('active'); 
    function normalizeTags(item) {
      if (!item.tags) return [];
      if (typeof item.tags === 'string') {
        return item.tags
          .split(',')
          .map(t => t.trim().toLowerCase())
          .filter(t => t.length > 0);
      }
      return item.tags.map(t => t.toString().trim().toLowerCase());
    }
   function updateTagCounts() {
      if (!window.apiResults || !Array.isArray(window.apiResults)) return;
      let total = window.apiResults.length;
      let countImmediate = 0;
      let count24 = 0;
      let count7 = 0;
      let count10 = 0;

      window.apiResults.forEach(item => {
        const tags = normalizeTags(item);
        if (tags.includes('xela') || tags.includes('marketplace')) {
          count24++;
        } else if (tags.includes('slowback')) {
          count10++;
        } else if (tags.includes('backorder') || tags.includes('bajopplcd')) {
          count7++;
        } else {
          countImmediate++;
        }
      });

      $('.redirect-tag-id[data-id="Todo"] .data-count-items').text(`(${total})`);
      $('.redirect-tag-id[data-id="Entrega inmediata"] .data-count-items').text(`(${countImmediate})`);
      $('.redirect-tag-id[data-id="Entrega en 24hrs"] .data-count-items').text(`(${count24})`);
      $('.redirect-tag-id[data-id="Entrega en 7 días"] .data-count-items').text(`(${count7})`);
      $('.redirect-tag-id[data-id="Entrega en 10 días"] .data-count-items').text(`(${count10})`);
      $('#sf-delivery-checkboxes .sf-delivery-item').each(function() {
        var cb = $(this).find('input[type="checkbox"]');
        var val = cb.val();
        var cnt = 0;
        if (val === 'Todo') cnt = total;
        else if (/inmediata/i.test(val)) cnt = countImmediate;
        else if (/24/i.test(val)) cnt = count24;
        else if (/7/i.test(val)) cnt = count7;
        else if (/10/i.test(val)) cnt = count10;
        $(this).find('.sf-checkbox-count').text('(' + cnt + ')');
        if (val === 'Todo') {
          $(this).show();
        } else {
          $(this).toggle(cnt > 0);
        }
      });
      $('.sf-mobile-bar__pill').each(function(){ var fid = $(this).data('filter-id'); var cnt = 0; if(/todo/i.test(fid)) cnt = total; else if(/inmediata/i.test(fid)) cnt = countImmediate; else if(/24/i.test(fid)) cnt = count24; else if(/7/i.test(fid)) cnt = count7; else if(/10/i.test(fid)) cnt = count10; $(this).find('.sf-mb-count').text('(' + cnt + ')'); if(/todo/i.test(fid)){ $(this).show(); } else { $(this).toggle(cnt > 0); } });
    }

      function filterResults(filterType) {
        if (!window.apiResults || !Array.isArray(window.apiResults)) return [];

        let filtered = [];
        filtered = window.apiResults.filter(item => {
          const tags = normalizeTags(item);
          if (tags.includes('xela') || tags.includes('marketplace')) {
            return filterType === 'Entrega en 24hrs';
          } else if (tags.includes('slowback')) {
            return filterType === 'Entrega en 10 días';
          } else if (tags.includes('backorder') || tags.includes('bajopplcd')) {
            return filterType === 'Entrega en 7 días';
          } else {
            return filterType === 'Entrega inmediata';
          }
        });
        if (filterType === 'Todo') filtered = window.apiResults;

        if (typeof renderCustomResults === 'function') {
          renderCustomResults(filtered, 1);
        }
      }

    let tries = 0;
    const interval = setInterval(() => {
      tries++;
      if (window.apiResults && window.apiResults.length) {
        updateTagCounts();
        $filterBar.show();
        clearInterval(interval);
      }
      if (tries > 10) clearInterval(interval); 
    }, 500);
    function cleanText(txt) {
      return $.trim(txt).toLowerCase();
    }
    $(document).on('click', '.redirect-tag-id', function (e) {
      e.preventDefault();
      var sfCbs = document.querySelectorAll("#sf-checkboxes input[type=checkbox]");
      for (var sc = 0; sc < sfCbs.length; sc++) { sfCbs[sc].checked = false; }
      var sfClearBtn = document.getElementById("sf-clear");
      if (sfClearBtn) sfClearBtn.classList.remove("sf-visible");
      if (window.__sfResetChecked) window.__sfResetChecked();
      const selected = cleanText($(this).data('id'));
      const $list = $('.custom-product-list--collection');
      const $pagination = $('.collection__dynamic-part .pagination');
      const $items = $list.find('.product-item');
      const $countDiv = $('.collection-custom-count');
      $('.redirect-tag-id').removeClass('active');
      $(this).addClass('active');
      var clickedId = cleanText($(this).data('id'));
      $('#sf-delivery-checkboxes input[type="checkbox"]').each(function() {
        $(this).prop('checked', cleanText($(this).val()) === clickedId);
      });
      $('.sf-mobile-bar__pill').removeClass('active').filter(function(){ return cleanText($(this).data('filter-id')) === clickedId; }).addClass('active');
      $list.find('.empty-filter-msg').remove(); 
      const $visibleItems = $items.filter(function () {
        var delivery = ($(this).attr('data-delivery') || '').toLowerCase();
        switch (selected) {
          case 'todo':
            return true;
          case 'entrega inmediata':
            return delivery === 'inmediata';
          case 'entrega en 24hrs':
            return delivery === '24hrs';
          case 'entrega en 7 días':
            return delivery === '7dias';
          case 'entrega en 10 días':
            return delivery === '10dias';
          default:
            return false;
        }
      });
      $items.hide();
      $visibleItems.show();
      const visibleCount = $visibleItems.length;
      const totalCount = $items.length;
      const anyVisible = visibleCount > 0;
      if ($countDiv.length) {
        if (anyVisible) {
          const showingText = `Mostrando 1 - ${visibleCount} de ${totalCount} resultados`;
          $countDiv.text(showingText).show();
        } else {
          $countDiv.text('Mostrando 0 resultados').show();
        }
      }
      if (!anyVisible) {
        $list.append('<div class="empty-filter-msg">No hay productos con este tiempo de entrega.</div>');
        $pagination.hide();
      } else {
        $pagination.show();
      }
    });

    $(document).on('click', '.sf-mobile-bar__pill', function (e) {
      e.preventDefault();
      var filterId = $(this).data('filter-id');
      if (!filterId) return;
      var sfCbs = document.querySelectorAll("#sf-checkboxes input[type=checkbox]");
      for (var sc = 0; sc < sfCbs.length; sc++) { sfCbs[sc].checked = false; }
      var sfClearBtn = document.getElementById("sf-clear");
      if (sfClearBtn) sfClearBtn.classList.remove("sf-visible");
      if (window.__sfResetChecked) window.__sfResetChecked();
      var selected = cleanText(filterId);
      $('.redirect-tag-id').removeClass('active');
      $('.redirect-tag-id').filter(function(){ return cleanText($(this).data('id')) === selected; }).addClass('active');
      $('.sf-mobile-bar__pill').removeClass('active');
      $(this).addClass('active');
      $('#sf-delivery-checkboxes input[type="checkbox"]').each(function() {
        $(this).prop('checked', cleanText($(this).val()) === selected);
      });
      var $list = $('.custom-product-list--collection');
      var $pagination = $('.collection__dynamic-part .pagination');
      var $items = $list.find('.product-item');
      var $countDiv = $('.collection-custom-count');
      $list.find('.empty-filter-msg').remove();
      var $visibleItems = $items.filter(function () {
        var delivery = ($(this).attr('data-delivery') || '').toLowerCase();
        switch (selected) {
          case 'todo': return true;
          case 'entrega inmediata': return delivery === 'inmediata';
          case 'entrega en 24hrs': return delivery === '24hrs';
          case 'entrega en 7 días': return delivery === '7dias';
          case 'entrega en 10 días': return delivery === '10dias';
          default: return false;
        }
      });
      $items.hide();
      $visibleItems.show();
      var visibleCount = $visibleItems.length;
      var totalCount = $items.length;
      if ($countDiv.length) {
        if (visibleCount > 0) {
          $countDiv.text('Mostrando 1 - ' + visibleCount + ' de ' + totalCount + ' resultados').show();
        } else {
          $countDiv.text('Mostrando 0 resultados').show();
        }
      }
      if (visibleCount === 0) {
        $list.append('<div class="empty-filter-msg">No hay productos con este tiempo de entrega.</div>');
        $pagination.hide();
      } else {
        $pagination.show();
      }
    });
  });
})(jQuery);